import React from 'react';
import { Table } from 'antd';

const SourcesTable = ({ sources }) => {
  if (!sources || sources.length === 0) return <p>No sources available.</p>;

  const columns = [
    {
      title: 'Type',
      dataIndex: 'sub-class',
      key: 'type',
    },
    {
      title: 'Source Ad Id',
      dataIndex: 'source-ad-id',
      key: 'type',
    },
    {
      title: 'Source Creative Id',
      dataIndex: 'source-creative-id',
      key: 'type',
    },
    {
      title: 'Updated At',
      dataIndex: 'updated-at',
      key: 'updatedAt',
      render: (text) => text || 'N/A',
    },
  ];

  return (
    <Table
      dataSource={sources.map((source, index) => ({ ...source, key: index }))}
      columns={columns}
      pagination={false}
      bordered
    />
  );
};

export default SourcesTable;
